module.exports = "<tf-orders-desktop-view>\n\n</tf-orders-desktop-view>";